import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  PlatformStudioApi,
  PlatformEntity,
  GenerateEntityRequest,
  GenerateEntityResponse,
} from './PlatformStudioApi';

export class PlatformStudioClient implements PlatformStudioApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return await this.discoveryApi.getBaseUrl('platform-studio');
  }

  async listEntities(kind: string): Promise<PlatformEntity[]> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/entities?kind=${kind}`);
    if (!resp.ok) throw new Error(`Failed to list ${kind} entities`);
    const data = await resp.json();
    return data.entities;
  }

  async getEntity(kind: string, name: string): Promise<PlatformEntity> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/entities/${kind}/${name}`);
    if (!resp.ok) throw new Error(`Entity ${kind}/${name} not found`);
    return await resp.json();
  }

  async generateEntity(request: GenerateEntityRequest): Promise<GenerateEntityResponse> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/generate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });
    if (!resp.ok) throw new Error('Entity generation failed');
    return await resp.json();
  }

  async checkSimilarity(
    kind: string,
    description: string,
  ): Promise<Array<{ name: string; score: number }>> {
    const base = await this.getBaseUrl();
    const resp = await this.fetchApi.fetch(`${base}/similarity`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind, description }),
    });
    if (!resp.ok) throw new Error('Similarity check failed');
    const data = await resp.json();
    return data.matches;
  }
}
